export default "__VITE_ASSET__DsFh4CfB__"